/* eslint-disable no-console */
import Skycon from '@/components/Skycon/Skycon'
import { Chrome } from 'vue-color'
import vSelect from 'vue-select'
import DatePicker from 'vue2-datepicker'
import axios from 'axios'
import config from '../../../config'
import DataModal from '../components/DataModal'
import { formatDate } from '../../../helper/helpernew'

export default {
  name: 'announcement',
  components: {
    Skycon,
    Chrome,
    vSelect,
    DatePicker,
    DataModal,
  },
  data() {
    return {
      data: [],
      columnsDatatable: ['no', 'ask', 'answer', 'created_at', 'updated_at', 'aksi'],
      tableOptions: {
        perPage: 10,
        pagination: { chunk: 10, dropdown: false },
        texts: { filter: '', count: '', limit: '' },
        // columnsClasses: { no: 'width-100', answer: 'text-wrap', aksi: 'width-50' },
        skin: 'table table-striped',
        sortIcon: {
          base: 'fa text-muted',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
      },
      editData: null,
    }
  },
  computed: {
    dataTable() {
      return this.data
        .sort((a, b) => a.id - b.id)
        .reduce(
          (acc, item, idx) => [
            ...acc,
            {
              ...item,
              index: idx,
              no: idx + 1,
            },
          ],
          [],
        )
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    formatDate,
    async getData() {
      const res = await axios.get(config.webprofileApiUrl + '/company-profile/faq')

      if (res.data) {
        this.data = res.data
      }
    },
    handleEdit(index) {
      this.editData = this.dataTable[index]
    },
    async handleSaveEdit(payload) {
      const id = this.editData.id

      try {
        let bodyFormData = new FormData()

        bodyFormData.append('ask', payload[0].value)
        bodyFormData.append('answer', payload[1].value)

        await axios({
          method: 'patch',
          url: config.webprofileApiUrl + `/company-profile/faq/${id}`,
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.$toasted.success('Berhasil Disimpan')
      } catch (err) {
        this.$toasted.error('Gagal Disimpan')
      } finally {
        this.getData()
      }
    },
    async handleDelete(index) {
      const id = this.dataTable[index].id

      if (confirm('Are you sure to delete?')) {
        try {
          await axios({
            method: 'delete',
            url: config.webprofileApiUrl + `/company-profile/faq/${id}`,
            headers: { 'Content-Type': 'multipart/form-data' },
          })

          this.$toasted.success('Berhasil Dihapus')
        } catch (err) {
          this.$toasted.error('Gagal Dihapus')
        } finally {
          this.getData()
        }
      }
    },
    async handleSaveAdd(payload) {
      try {
        let bodyFormData = new FormData()

        bodyFormData.append('ask', payload[0].value)
        bodyFormData.append('answer', payload[1].value)

        await axios({
          method: 'post',
          url: config.webprofileApiUrl + '/company-profile/faq',
          data: bodyFormData,
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        this.$toasted.success('Berhasil Ditambahkan')
      } catch (err) {
        this.$toasted.error('Gagal Ditambahkan')
      } finally {
        this.getData()
      }
    },
  },
}
